import { useState } from "react"
import { Button, ListGroup, Modal } from "react-bootstrap"
import { EditLinkedServiceModal } from "../../Modals/EditLinkedServiceModal/EditLinkedServiceModal"
import {
  BookingLinkedServiceCategory,
  bookingLinkedServiceCategories,
  bookingLinkedServiceCategory,
  describeBookingLinkedService,
} from "./BookingLinkedServiceHelpers"

type EditingState = { index: number, entry: any, title: string }

export default function BookingLinkedServices(props: {
  linkedServices: any[],
  setFieldValue: (field: string, value: any) => void,
}) {
  const { linkedServices, setFieldValue } = props

  const [pickerCategory, setPickerCategory] = useState<BookingLinkedServiceCategory | ''>('')
  const [editing, setEditing] = useState<EditingState | null>(null)

  const entriesByCategory = bookingLinkedServiceCategories.map((category) => ({
    ...category,
    entries: linkedServices
      .map((entry, index) => ({ entry, index }))
      .filter(({ entry }) => bookingLinkedServiceCategory(entry?.linkedService) === category.key),
  }))

  const pickerCategoryInfo = entriesByCategory.find((category) => category.key === pickerCategory)
  const hasRemoteLock = entriesByCategory.find((category) => category.key === 'remoteLock')?.entries.length

  const startEditing = (label: string, index: number, entry: any) => {
    setPickerCategory('')
    setEditing({ index, entry, title: `Edit ${label}` })
  }

  return (
    <>
      {!hasRemoteLock && (
        <Button
          className="me-2 mb-2"
          variant="secondary"
          size="sm"
          onClick={() => setEditing({
            index: -1,
            entry: { linkedService: 'remoteLock', linkedServiceId: '' },
            title: 'Add Remote Lock',
          })}
        >
          + Remote Lock
        </Button>
      )}

      {entriesByCategory.map(({ key, label, entries }) => {
        if (entries.length === 0) {
          return null
        }
        return (
          <Button
            key={`edit-booking-linked-service-btn-${key}`}
            className="me-2 mb-2"
            variant="outline-primary"
            size="sm"
            onClick={() => {
              if (entries.length === 1) {
                startEditing(label, entries[0].index, entries[0].entry)
              } else {
                setPickerCategory(key)
              }
            }}
          >
            Edit {label}{entries.length > 1 ? ` (${entries.length})` : ''}
          </Button>
        )
      })}

      <Modal show={!!pickerCategoryInfo} onHide={() => setPickerCategory('')}>
        <Modal.Header closeButton>
          <Modal.Title>Select {pickerCategoryInfo?.label} Entry</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ListGroup>
            {pickerCategoryInfo?.entries.map(({ entry, index }) => (
              <ListGroup.Item
                key={`booking-linked-service-entry-${index}`}
                action
                onClick={() => startEditing(pickerCategoryInfo.label, index, entry)}
              >
                {describeBookingLinkedService(entry)}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Modal.Body>
      </Modal>

      <EditLinkedServiceModal
        active={!!editing}
        onClose={() => setEditing(null)}
        linkedServiceData={editing?.entry}
        title={editing?.title}
        linkedServiceType="booking"
        onSave={(updatedEntry: any) => {
          if (!editing) {
            return
          }
          const updatedLinkedServices = [...linkedServices]
          if (editing.index === -1) {
            updatedLinkedServices.push(updatedEntry)
          } else {
            updatedLinkedServices[editing.index] = updatedEntry
          }
          setFieldValue('linkedServices', updatedLinkedServices)
          setEditing(null)
        }}
      />
    </>
  )
}
